import { createFileRoute } from "@tanstack/react-router";
import Book from "@/pages/Book";
import {
  buildPageHead,
  breadcrumbSchema,
  contactPageSchema,
  personSchema,
} from "@/lib/seo";

export const Route = createFileRoute("/book")({
  head: () =>
    buildPageHead({
      title: "Book a Free Discovery Call | Marjohn Robillo | RevOps Architect",
      description:
        "Book a free 30-minute discovery call with Marjohn Robillo, Revenue Operations Architect. Map your CRM, automation, and revenue systems: no payment, discovery only, calendar synced to your timezone.",
      path: "/book",
      keywords:
        "book a call, book discovery call, revenue operations consultation, CRM automation consultation, free strategy call, Marjohn Robillo booking",
      robots: "index, follow, max-image-preview:large, max-snippet:-1",
      schema: [
        contactPageSchema(),
        personSchema(),
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Book a Call", path: "/book" },
        ]),
      ],
    }),
  component: Book,
});
